<!-- eslint-disable -->
<template>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      :width="width" :height="height" :fill="fill" viewBox="0 0 437.474 437.474" style="enable-background:new 0 0 437.474 437.474;"
    xml:space="preserve">
    <g>
      <g>
        <path d="M340.438,179.806c21.82-24.429,34.89-128.092,34.89-128.092s-101.534,24.647-123.354,49.077
          c-21.818,24.43-15.923,57.688,8.507,79.507C284.909,202.118,318.618,204.235,340.438,179.806z"/>
        <path d="M127.248,340.863c-21.819,24.43-15.923,57.689,8.507,79.508c24.429,21.82,58.139,23.938,79.958-0.492
          c21.82-24.428,34.89-128.092,34.89-128.092S149.068,316.436,127.248,340.863z"/>
        <path d="M300.927,261.548c-12.682,14.196-9.256,33.526,4.941,46.209c14.199,12.683,33.793,13.912,46.475-0.285
          c12.683-14.198,20.277-74.448,20.277-74.448S313.609,247.349,300.927,261.548z"/>
        <path d="M164.118,258.214c21.82-24.431,34.889-128.092,34.889-128.092S97.474,154.769,75.653,179.199
          c-21.82,24.429-15.924,57.687,8.506,79.506C108.589,280.525,142.299,282.643,164.118,258.214z"/>
        <path d="M172.046,71.278c13.541,12.095,32.229,13.27,44.324-0.273C228.465,57.463,235.709,0,235.709,0
          s-56.284,13.662-68.38,27.204C155.235,40.746,158.503,59.182,172.046,71.278z"/>
      </g>
    </g>
  </svg>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: 'IconRaindrops',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: 'var(--dark)',
    },
  },
};
</script>
